/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
// custom components
import NumberedHeading from "../../../../../../shared-components/forms/NumberedHeading";
import AssessmentLureArray from './AssessmentLureArray';

const SingleListeningMCQuestion = ({control, errors, inputDir }) => {

  return (
    <div>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
        className="px-0"
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="secondary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent className="pr-0">
            <div>
              <NumberedHeading number="1" title="Question (Prompt)" instructions='Enter the question text here in the target language.' />
              <Controller
                control={control}
                name="content.question.prompt"
                render={({ field }) => (
                  <>
                    <TextField
                      {...field}
                      className="mt-16 mb-16"
                      label="Text"
                      placeholder="Text"
                      error={!!errors?.content?.question?.prompt}
                      helperText={errors?.content?.question?.prompt?.message}
                      fullWidth
                      multiline
                      minRows={5}
                      maxRows={10}
                      required
                      dir={inputDir}
                    />
                  </>
                )}
              />

              <NumberedHeading number="2" title="Start Time (Minute)" instructions="Enter a start time (minute) for the media." />
              <Controller
                control={control}
                name="content.question.start_minute"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="Start Time (Minute)"
                    placeholder="Start Time (Minute)"
                    error={!!errors.content?.question?.start_minute}
                    helperText={errors.content?.question?.start_minute?.message}
                    fullWidth
                    required
                    type="number"
                  />
                )}
              /> 

              <Divider className="mt-16" />

              <NumberedHeading number="3" title="Start Time (Second)" instructions="Enter a start time (second) for the media." />
              <Controller
                control={control}
                name="content.question.start_second"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="Start Time (Second)"
                    placeholder="Start Time (Second)"
                    error={!!errors.content?.question?.start_second}
                    helperText={errors.content?.question?.start_second?.message}
                    fullWidth
                    required
                    type="number"
                  />
                )}
              />

              <NumberedHeading number="4" title="End Time (Minute)" instructions="Enter an end time (minute) for the media." />
              <Controller
                control={control}
                name="content.question.end_minute"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="End Time (Minute)"
                    placeholder="End Time (Minute)"
                    error={!!errors.content?.question?.end_minute}
                    helperText={errors.content?.question?.end_minute?.message}
                    fullWidth
                    required
                    type="number"
                  />
                )}
              /> 

              <Divider className="mt-16" />

              <NumberedHeading number="5" title="End Time (Second)" instructions="Enter a end time (second) for the media." />
              <Controller
                control={control}
                name="content.question.end_second"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mt-16 mb-16"
                    label="End Time (Second)"
                    placeholder="End Time (Second)"
                    error={!!errors.content?.question?.end_second}
                    helperText={errors.content?.question?.end_second?.message}
                    fullWidth
                    required
                    type="number"
                  />
                )}
              />

              <Divider className="mt-16" />

              <NumberedHeading number="6" title="Options (Lures)" instructions='Using the controls below, please add options (lures) for the question.' />
              <Controller
                control={control}
                name="content.question.lures"
                render={({ field }) => <AssessmentLureArray inputDir={inputDir} {...{ control, errors }} />}
              />

              <Divider className="mt-16" />

              <NumberedHeading number="7" title="Multiple Select" instructions="Check the box if there is more than one correct answer." />
              <Controller
                control={control}
                name="content.question.multi_select"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox 
                        onChange={(ev) => {
                          field.onChange(ev.target.checked);
                        }}
                        checked={field.value}
                      />
                    }
                    label='Multiple Select'
                  />
                )}
              />
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
};

export default SingleListeningMCQuestion;